import React from 'react';

import {agent as agentUrl} from '../../../util/urls';
import {Tab} from '../Tab';
import {Tabs} from '../Tabs';

type AgentDetailTabsProps = {
  entityName: string;
  agentId: string;
  tab: string;
};

export const AgentDetailTabs = ({
  entityName,
  agentId,
  tab,
}: AgentDetailTabsProps) => {
  return (
    <Tabs value={tab}>
      <Tab
        label="Overview"
        value="overview"
        href={agentUrl(entityName, agentId, 'overview')}
      />
      <Tab
        label="Logs"
        value="logs"
        href={agentUrl(entityName, agentId, 'logs')}
      />
    </Tabs>
  );
};
